'use client';

import { c as _c } from "react/compiler-runtime";
import { useOnMount } from '@src/hooks/useOnMount';
import useGeolocationStore from '@src/stores/geolocationStore';
import { log } from '@src/utils/log.util';
export type GeoApiResponse<T> = {
  status: 'success' | 'fail' | 'error';
  data: null | T;
  message?: string;
  code?: number;
};
export interface Geolocation {
  country: string | undefined;
  countryRegion: string | undefined;
  region: string | undefined;
  city: string | undefined;
  latitude: string | undefined;
  longitude: string | undefined;
}
export const getGeolocation = async () => {
  const geoLocationEndpoint = '/api/edge-geo';

  // NOTE: We fall back to sending a default response to distinguish it from being
  // null when initialized. This indicates that the fetch was made, but no data was returned.
  const defaultResponse: Geolocation = {
    country: '',
    countryRegion: '',
    city: '',
    region: '',
    latitude: '',
    longitude: ''
  };
  try {
    const res = await fetch(geoLocationEndpoint);
    const resJson: GeoApiResponse<Geolocation> = await res.json();
    if (resJson.data && res.ok) {
      return resJson.data;
    }
    return defaultResponse;
  } catch (error: any) {
    log.error(`Error ${geoLocationEndpoint} - ${error?.message}`, error);
    return defaultResponse;
  }
};
export const useGeolocation = () => {
  const $ = _c(2);
  const setGeoLocation = useGeolocationStore(_temp);
  let t0;
  if ($[0] !== setGeoLocation) {
    t0 = () => {
      getGeolocation().then(setGeoLocation);
    };
    $[0] = setGeoLocation;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useOnMount(t0);
};
export const getLocation = (geoLocation: Geolocation | null): [string, string] | null => {
  if (geoLocation?.latitude && geoLocation.longitude) {
    const {
      latitude,
      longitude
    } = geoLocation;
    return [latitude, longitude];
  }
  return null;
};
function _temp(state) {
  return state.setGeoLocation;
}